/**
 * KETIX3D logo — real brand asset, per the "never recreate/redesign the
 * logo" rule. Renders the supplied PNG (public/brand/ketix3d-logo.png),
 * which already includes the wordmark + tagline, so no separate text is
 * layered on top of it.
 */
export function Logo({ className = '' }: { className?: string }) {
  return (
    <img
      src="/brand/ketix3d-logo.png"
      alt="KETIX3D — Entertainment. Technology. Innovation."
      className={`h-14 w-auto object-contain ${className}`}
    />
  );
}
